import Vue from 'vue';
import Vuex from 'vuex';
import state from "./state";
import mutations from "./mutations";
import actions from "./actions";
import createPersistedState from "vuex-persistedstate";
// 

/**
 * filter:()=>window.__CANCEL_PERSIST,
 * 
      filter:()=>window.__CANCEL_PERSIST,
 */
Vue.use(Vuex);

export default new Vuex.Store({
  state,
  mutations,
  actions,
  plugins: [
    createPersistedState({
      storage:window.sessionStorage,
      key:'isShowMsg',
      reducer(val){
        return val.isShowMsg
      }
    }),
    createPersistedState({
      storage: window.localStorage,
      key: "token",
      reducer(val) {
        return {
          // 只储存state中的userInfo
          token: val.token,
          userInfo:val.userInfo,
          yshCollectSchool:val.collectSchool,
          yshCollectZyzSchool:val.collectSchoolZyz,
          yfLoadElement:val.yfLoadElement,
          whsSchoolFindData:val.schoolFindData,
          whsRecommendData:val.recommendData,
          userType:val.userType,
          isUpdateToken:val.isUpdateToken
        };
      }
    }),
    createPersistedState({
      storage:window.localStorage,
      key:"user",
      reducer(val){
        return {
          userName:val.userName,
          userPwd:val.userPwd,
          isMd5:val.isMd5
        };
      }
    }),
    createPersistedState({
      storage:window.localStorage,
      key:"collectInfo",
      reducer(val){
        return{
          value:val.collectInfo
        };
      }
    }),
    createPersistedState({
      storage:window.localStorage,
      key:"compareSchool",
      reducer(val){
        return{
          value:val.compareSchool
        };
      }
    }),
    createPersistedState({
      storage:window.localStorage,
      key:"userType",
      reducer(val){
        return{
          value:val.userType
        };
      }
    }),
    createPersistedState({
      storage:window.localStorage,
      key:"ysCollectInfo",
      paths:['ysCollectInfo'],
    })
  ],
  modules: {
  }
});
